
export function setInterceptor(instance, customHeader) {
  instance.interceptors.request.use(
    config => {
      // console.debug(config);
     if(customHeader) {
         config.headers[customHeader.key] = customHeader.value;
     }
      return config;
    },
    error => {
      console.debug(error);
      return Promise.reject(error);
    },
  );
  instance.interceptors.response.use(
    response => {
      console.debug(response);
      return response;
    },
    error => {
      return Promise.reject(error);
    },
  );
  return instance;
}
